import { InstagramLogo, ArrowUpRight } from "@phosphor-icons/react";

const NEON_IMG =
  "https://customer-assets.emergentagent.com/job_slay-aesthetic-boost/artifacts/c7xf6eol_CEBC811F-CCAB-4A09-A66E-6D8B9203D7F0.jpeg";

export default function Social() {
  return (
    <section
      id="social"
      data-testid="social-section"
      className="relative px-6 md:px-12 lg:px-20 py-16 lg:py-20 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Left - copy */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#FF1B91]" />
              <p className="text-[11px] uppercase tracking-[0.4em] text-[#FF1B91] font-semibold">Follow Along / 07</p>
            </div>
            <h2 className="font-display font-black uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.9] tracking-tighter mb-6">
              Off the grid.{" "}
              <span className="font-brush font-normal normal-case text-[#FF1B91] inline-block transform -rotate-2">on the gram.</span>
            </h2>
            <p className="text-white/70 leading-relaxed max-w-md mb-8">
              Daily drops — workouts, mindset notes, behind-the-scenes. The vibe lives on Instagram.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://instagram.com/sweatwithslay"
                target="_blank"
                rel="noreferrer noopener"
                data-testid="social-instagram-brand"
                className="inline-flex items-center justify-center gap-3 bg-[#FF1B91] hover:bg-[#FF3FA3] text-white px-6 py-4 text-xs font-bold uppercase tracking-[0.2em] btn-brutal btn-brutal-pink"
              >
                <InstagramLogo size={18} weight="bold" /> @sweatwithslay <ArrowUpRight size={14} weight="bold" />
              </a>
              <a
                href="https://instagram.com/alannajohnson"
                target="_blank"
                rel="noreferrer noopener"
                data-testid="social-instagram-personal"
                className="inline-flex items-center justify-center gap-3 border border-white/40 hover:border-white text-white px-6 py-4 text-xs font-bold uppercase tracking-[0.2em] transition-colors"
              >
                <InstagramLogo size={18} weight="bold" /> @alannajohnson
              </a>
            </div>
          </div>

          {/* Right - clean image */}
          <div className="lg:col-span-7">
            <a
              href="https://instagram.com/sweatwithslay"
              target="_blank"
              rel="noreferrer noopener"
              data-testid="social-instagram-image"
              className="block relative border border-white/10 overflow-hidden group"
            >
              <img
                src={NEON_IMG}
                alt="Sweat With Slay"
                className="w-full h-[50vh] lg:h-[60vh] object-cover group-hover:scale-[1.02] transition-transform duration-700"
              />
              <span className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-black/60 backdrop-blur-sm border border-white/10 opacity-0 group-hover:opacity-100 transition-opacity">
                <ArrowUpRight size={16} weight="bold" className="text-white" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
